import { ApprovalMaterializedApprovalFragment } from 'generated/resources/graphql'

import type { RequestComponentProps } from 'modules/notifications/pages/RequestsPage/RequestItems/RequestItem/base'

import BasePendingApproval from 'modules/notifications/pages/RequestsPage/RequestItems/RequestItem/CustomContent/PendingApprovals/BasePendingApprovals'
import LeftBlock from './components/LeftBlock'
import RightBlock from './components/RightBlock'
import { CollapseContentData } from './types'

const AtsApprovals = ({ request, index, compact, removeRequestById }: RequestComponentProps) => {
  const fetchResources = async (flow: ApprovalMaterializedApprovalFragment) => ({
    resourceId: flow.resourceId,
  })

  return (
    <BasePendingApproval
      request={request}
      index={index}
      compact={compact}
      getApprovalData={(flow) => fetchResources(flow)}
      removeRequestById={removeRequestById}
      collapseContentBlocks={(data) => ({
        leftBlock: <LeftBlock collapseContentData={data as CollapseContentData} />,
        rightBlock: <RightBlock collapseContentData={data as CollapseContentData} />,
      })}
    />
  )
}

export default AtsApprovals
